<template>
  <div class="jdjr-official-website-topbanner" :id="0">
    <div class="jdjr-official-website-topbanner-children">
      <HomeBanner/>
      <div
        class="children-position-father"
        :class="[ scrollShow && initScroll ? 'activePositionFather' : 'scroll-down-class' ]"
      >
        <div class="children-position--children">
          <img
            :src="scrollShow ? require('@/assets/img/logo-black.png') :  require('@/assets/img/logo-white.png')"
            class="topbanner-children-logo"
          />
          <div></div>
          <div class="topbanner-children-tabs">
            <span
              v-for="(obj, index) in data"
              :key="index"
              @click="changeTabsName(index)"
              :class="{ activeClass: tabsIndex === index }"
              :clstag="index === 4 ? 'DSGJ|85737' : index === 5 ? 'DSGJ|85738' : ''"
              >{{ obj }}</span
            >
            <span class="network-six">网络支持<b>IPv6</b></span>
          </div>
        </div>
      </div>
      <!-- <img
        src="@/assets/img/top-title.png"
        class="topbanner-children-bannertext"
      /> -->
    </div>
    <Modal :dialogVisible="downloadAPP" @clsoeModal="clsoeModal" />
  </div>
</template>

<script>
import Modal from "./modal.vue";
import HomeBanner from './homeBanner.vue'
export default {
  name: "Topchild",

  components: {
    Modal,
    HomeBanner
  },

  data() {
    return {
      data: ["首页","产品服务","企业社会责任", "合作伙伴","下载APP"],
      tabsIndex: 0,
      downloadAPP: false,
      scrollShow: false,
      oldScrollTop:0,
      initScroll:false
    };
  },

  mounted() {
    window.addEventListener("scroll", this.onScroll, false);
  },

  destroyed() {
    document.documentElement.scrollTop = 0
    window.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll(e) {
      // this.scrollTop = document.documentElement.scrollTop;
      this.initScroll = true
      // 滚动条距文档顶部的距离
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      // 滚动条滚动的距离
      let scrollStep = scrollTop - this.oldScrollTop;
      // // 更新——滚动前，滚动条距文档顶部的距离
      // console.log(scrollStep)
      this.oldScrollTop = scrollTop;
      if (scrollStep < 0) {
        // alert("滚动条向上滚动了！");
        this.scrollShow = true
      } else {
        // alert("滚动条向下滚动了！");
        this.scrollShow = false
      }
      if(scrollTop < 50){
        this.scrollShow = false
      }
    },
    changeTabsName(index) {
      this.tabsIndex = index;
      if(index === 0){
        this.downloadAPP = false;
        this.scrollShow = false
      } else {
        this.scrollShow = true
      }
      // if(index === 4){
      //   window.open('https://jrhelp.jd.com/show/showCustomService')
      // }
      if (index === 4) {
        this.downloadAPP = true;
        this.scrollShow = false
        return;
      }
      const node = document.getElementById(index);
      if (node) {
        const scrollTop = node.offsetTop;
        console.log(scrollTop);
        window.scrollTo({
          top: index === 0 ? 0 : scrollTop - 110,
          behavior: "smooth",
        });
      }
    },
    clsoeModal(val) {
      this.downloadAPP = val;
      this.scrollShow = false
      this.tabsIndex = 0
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.jdjr-official-website-topbanner {
  height: 1080px;
  // background: url("@/assets/img/top-img.png") no-repeat;
  // background-size: 100% 1080px;
  .jdjr-official-website-topbanner-children {

    .children-position-father {
      transition: all .3s linear;
      height: 120px;
      .children-position--children {
        width: 1440px;
        height: 120px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: auto;
      }
      // background: #fff;
      .topbanner-children-logo {
        width: 180px;
        height: 41px;
        z-index: 10;
      }
      .topbanner-children-tabs {
        background: none;
        height: 28px;
        // margin-top: 46px;
        display: flex;
        border-color: rgba(255, 255, 255, 1);
        line-height: 28px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        z-index: 10; 
        span {
          height: 28px;
          margin-right: 60px;
          position: relative;
          line-height: 28px;
          cursor: pointer;
        }
        .network-six{
          cursor: default;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: normal;
          color: rgba(0,199,255,1);
          line-height: 28px;
          height: 28px;
          display: flex;
          align-items: center;
          b {
            display: inline-block;
            line-height: 25px;
            text-align: center;
            width: 50px;
            height: 25px;
            border: 1px solid rgba(0,199,255,1);
            border-radius: 4px;
            margin-left: 8px;
            font-weight: normal;
          }
        }
        .activeClass {
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            bottom: -10px;
            left: 0;
            border-bottom: 2px solid rgba(255, 255, 255, 1);
          }
        }
      }
    }
    .scroll-down-class{
      top: -120px;
      transition: all .3s linear;
    }
    .activePositionFather {
      width: 100vw;
      height: 120px;
      box-sizing: border-box;
      position: fixed;
      top: 0;
      z-index: 100;
      transition: all .3s linear;
      background: rgba(255, 255, 255, 1);
      .children-position--children{
        margin-top: 0px;
      }
      .topbanner-children-tabs {
        color: rgba(51, 51, 51, 1);
        .activeClass {
          &::after {
            content: "";
            border-bottom: 2px solid rgba(239, 64, 52, 1);
          }
        }
      }
    }
    .topbanner-children-bannertext {
      position: absolute;
      top: 350px;
      left: 0;
      width: 700px;
      height: 320px;
      margin-left: 245px;
    }
  }
}
</style>
